import namespaceHelper from '@/shared/helpers/namespace-helper';
import { namespace, CusEcommerceActions, CusEcommerceMutations } from './types';
import BranchService from '@/shared/services/BranchService';
import CusECommerceService from '@/shared/services/CusECommerceService';

const _actions = namespaceHelper.removeNamespace(namespace, CusEcommerceActions);
const _mutations = namespaceHelper.removeNamespace(namespace, CusEcommerceMutations);

export default {
  async [_actions.SEARCH_PARTS]({ commit }, params) {
    const partList = await BranchService.getCusECommerceParts(params.branchId, params.search);
    commit(_mutations.SET_PART_LIST, partList.data);
  },
  async [_actions.SUBMIT_PARTS](_, payload) {
    const response = await CusECommerceService.submitPartsOrder(payload);
    return response;
  },
  async [_actions.SEND_MESSAGE](_, payload) {
    const response = await CusECommerceService.sendMessage(payload);
    return response;
  },
  async [_actions.GET_PART_QUOTE](_, params) {
    const response = await BranchService.getCusECommercePartQuote(params.branchId, params.customerId, params.part);
    return response;
  }
};
